const API_ADMIN = `${process.env.REACT_APP_API_URL}/api/admin`;
const API_GESTIONNAIRE = `${process.env.REACT_APP_API_URL}/api/gestionnaire`;

export default class SocieteService {

    static async getAll(token, role = "admin") {
        try {
            const baseUrl = role === "admin" ? API_ADMIN : API_GESTIONNAIRE;
            const response = await fetch(`${baseUrl}/societes`, {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || `Erreur HTTP ${response.status}`);
            }

            const result = await response.json();

            if (result.success && Array.isArray(result.data)) {
                return result.data;
            } else {
                return Array.isArray(result) ? result : [];
            }

        } catch (error) {
            console.error("SocieteService.getAll() → erreur :", error);
            throw error;
        }
    }

}